import { css } from '@emotion/core';
import { Button, CircularProgress, Typography } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import * as React from 'react';

import { Profile } from 'shared/profile-search/profile';
import { useSearchResults } from '../../hooks/use-agent-search-draft';
import { ProfilePreview } from '../profile/profile-preview';

const REFRESH_ICON_SIZE = 16;

const styles = css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    padding: 12px 0 18px;
`;

interface SearchResultsListProps {
    limit?: number;
    onProfileClick?: (personId: string) => void;
}

export const SearchResultsList: React.FC<SearchResultsListProps> = ({ limit, onProfileClick }) => {
    const { profiles, resultsExpired, handleRefresh, refreshing } = useSearchResults();

    if (resultsExpired) {
        const icon = refreshing ? <CircularProgress size={REFRESH_ICON_SIZE} /> : <RefreshIcon />;
        return (
            <div css={styles}>
                <Typography color="textSecondary" variant="body2">
                    Search results have expired. Click refresh to re-run the search.
                </Typography>
                <Button
                    color="primary"
                    disabled={refreshing}
                    onClick={handleRefresh}
                    size="small"
                    startIcon={icon}
                    variant="outlined"
                >
                    {refreshing ? 'Refreshing...' : 'Refresh Results'}
                </Button>
            </div>
        );
    }

    const items = profiles.slice(0, limit).map((result) => {
        const profile = result.profile as Profile;
        const handleClick = onProfileClick ? () => onProfileClick(result.personId) : undefined;
        return (
            <div key={result.personId} className="profile-preview" onClick={handleClick}>
                <ProfilePreview profile={profile} onClick={handleClick} />
            </div>
        );
    });

    return <>{items}</>;
};
